import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-subscription',
  templateUrl: './confirm-subscription.component.html',
  styleUrls: ['./confirm-subscription.component.scss']
})
export class ConfirmSubscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
